<template>
    <div class="d-flex flex-column nav-items">
        <template
            v-for="entry in visibleStepGroups"
            :key="entry.type === 'group' ? entry.parent : entry.step.key">
            <!-- Normal top-level step -->
            <NuxtLink
                v-if="entry.type === 'step'"
                class="nav-item d-flex align-items-center justify-content-between"
                :to="{
                    path: $localePath({name: 'registration-id-' + entry.step.name}),
                    query: $route.query
                }"
                :class="{'disabled': entry.step.disabled}">
                <Component
                    :is="menuItemComponent(entry.step.name)"
                    class="menu-items" />
                <font-awesome-icon
                    :icon="stepStatusIcon(entry.step).icon"
                    :class="[stepStatusIcon(entry.step).className, 'ml-2']"
                    fixed-width />
            </NuxtLink>

            <!-- Exploded question step with its page-break sub-pages -->
            <div
                v-else
                class="step-group">
                <div
                    class="nav-item group-header"
                    :class="{'disabled': entry.steps[0].disabled}"
                    @click="goToStep(entry.steps[0])">
                    <Component
                        :is="menuItemComponent(entry.parent)"
                        class="menu-items" />
                </div>
                <div class="sub-pages">
                    <div
                        v-for="subStep in entry.steps"
                        :key="subStep.key"
                        class="nav-item sub-page"
                        :class="{'disabled': subStep.disabled, 'active': subStep.key === activeStep?.key}"
                        @click="goToStep(subStep)">
                        <MenuItemSubPage
                            :step="subStep"
                            :status="stepStatus(subStep)" />
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import MenuItemParticipants from "@/components/layouts/eventRegistration/MenuItemParticipants";
import MenuItemRegistrationDetails from "@/components/layouts/eventRegistration/MenuItemRegistrationDetails";
import MenuItemParticipantsDetails from "@/components/layouts/eventRegistration/MenuItemParticipantsDetails";
import MenuItemPayment from "@/components/layouts/eventRegistration/MenuItemPayment";
import MenuItemRegSummary from "@/components/layouts/eventRegistration/MenuItemRegSummary";
import MenuItemSubPage from "@/components/layouts/eventRegistration/MenuItemSubPage";
import registrationStepsAndValidationMixin from "@/mixins/registration/registrationStepsAndValidationMixin";
import MenuItemRegStart from "@/components/layouts/eventRegistration/MenuItemRegStart";


export default {
    name: "RegistrationMenu",
    components: {
        MenuItemRegSummary,
        MenuItemRegStart,
        MenuItemPayment,
        MenuItemParticipantsDetails,
        MenuItemRegistrationDetails,
        MenuItemParticipants,
        MenuItemSubPage
    },
    mixins: [registrationStepsAndValidationMixin],
    data() {
        return {
            stepName: null
        }
    }
}
</script>

<style lang="scss" scoped>
@use "sass:map";

.nav-items > * {
    margin-bottom: map.get($spacers, 2);
}

.nav-item {
    color: var(--custom-text-color, $nav-item-color);
    font-size: $font-size-sm;
    padding: map.get($spacers, 1) map.get($spacers, 2);
    user-select: none;
    cursor: pointer;

    > span {
        margin-left: map.get($spacers, 1);
    }
}

.nav-item.nuxt-link-active,
.nav-item.active {
    background: $gray-400;
    border-radius: 0.375rem;
    color: var(--custom-heading-color, $nav-item-hover-color) !important;
}

.nav-item:hover {
    color: var(--custom-heading-color, $nav-item-hover-color);
}

.nav-item.disabled {
    color: color-mix(in srgb, var(--custom-text-color, $nav-item-color) 45%, transparent);
    pointer-events: none;
}

.step-group .sub-pages {
    margin-left: map.get($spacers, 3);
}

.step-group .sub-page {
    font-size: $font-size-sm;
}

.menu-items > :nth-child(2) {
    margin-left: map.get($spacers, 2);
}
</style>
